import React from "react";

export function VaEligibleIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 44.95 50"
      width="30"
      height="30"
      fill="white"
      {...props}
    >
      <polygon points="22.91 50 0 34.14 0 26.2 22.91 42.07 44.95 26.2 44.95 34.14 22.91 50" />
      <polygon points="22.91 35.9 0 20.03 0 12.1 22.91 27.97 44.95 12.1 44.95 20.03 22.91 35.9" />
      <polygon points="22.63 0 25.08 5.9 30.89 5.78 26.3 9.66 29.31 16 22.76 12.3 16.52 16.3 19.26 9.66 14.06 5.78 20.17 5.9 22.63 0" />
    </svg>
  );
}
